/**
 * Which environment a bundle is built for, as the tab title names it: null
 * in production, the stage's name where `deploy.sh` built for one, and
 * `local` for the dev server and any build that names no stage.
 */
export function environmentLabel(): string | null {
  if (import.meta.env.DEV) return 'local'
  const stage = import.meta.env.VITE_ENVIRONMENT
  if (stage === 'prod') return null
  return stage || 'local'
}
